import React from 'react';
import { useRouter } from 'next/router';

import { Paginate } from 'app/seedly-component-library';
import buildConfig from 'app/utils/buildConfig';

const ProductSitemapContent = ({ products = [], pagination = {} }) => {
  const router = useRouter();

  return (
    <div className="flex w-[1024px] px-0 py-6">
      <div className="flex flex-col gap-6 w-full items-center">
        <div className="p-4 bg-white rounded w-full h-fit">
          <div className="flex flex-col gap-6 w-full">
            <h1 className="font-bold text-2xl">Financial Products Sitemap</h1>
            <ul className="w-full columns-[200px] space-y-4">
              {products.map(product => {
                const url = `${buildConfig.apiHost}/reviews/${product.categorySlug}/${product.slug}`;

                return (
                  <li key={product.name}>
                    <a
                      className="text-blue-500"
                      href={url}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {product.name}
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
        <Paginate
          pageCount={pagination.totalPage}
          forcePage={pagination.currentPage - 1}
          onPageChange={page => {
            router.push(`/sitemap/products/${page.selected + 1}/`);
          }}
        />
      </div>
    </div>
  );
};

export default ProductSitemapContent;
